import MainCard from "components/MainCard";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { FetchAllWhatsappTemplates, FetchPostingChannel } from "store/action/index";
import { dispatch } from "store/index";
import { Table, Modal, Spin, Tag } from "antd";
import { FetchChannelColumnses } from "components/columns/columns";

const FetchChannel = ({ allwhatsappchannel }) => {
    const [loading, setLoading] = useState(true)
    let params = { team_id: localStorage.getItem("teams_id") }

    useEffect(() => {
        dispatch(FetchPostingChannel({ setLoading: setLoading, params }));
    }, [])

    return (
        <>
            <MainCard>
                <div style={{ overflowX: "auto" }}>
                    <Table
                        className="border rounded"
                        style={{ marginTop: 25 }}
                        loading={loading}
                        dataSource={allwhatsappchannel ?? []}
                        columns={FetchChannelColumnses()}
                    />
                </div>
            </MainCard>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        allwhatsappchannel: state.AllWhatsappChannnel.allwhatsappchannel,
    };
};

export default connect(mapStateToProps)(FetchChannel);